document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  const previous = event.detail.previousVariant;
  const variants = getVariants();
  if (!variant || !previous) return;

  // Query variant parts elements
  const variantParts = document.querySelectorAll('.variant-parts');
  if (variantParts) {
    // Get closest section to variant Parts
    const partsSection = variantParts[0].closest('section');
    if (partsSection) {
      const sectionID = partsSection.id;
      // Dynamically update section with variant parts
      fetch(`${window.location.pathname}?variant=${variant.id}?sections=${sectionID}`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newVariantParts = doc.querySelectorAll('.variant-parts');
          if (newVariantParts) {
            variantParts.forEach((e, i) => {
              if (newVariantParts[i]) {
                e.replaceWith(newVariantParts[i]);
              }
            })
          }
        })
        .catch(error => {
          console.error('Error updating the variant parts specification table:', error);
        })
    }
  };
});

function getVariants() {
  const exposedJSON = document.getElementById('product-variants').innerHTML;
  if (exposedJSON) {
    try {
      return JSON.parse(exposedJSON);
    } catch (e) {
      console.error('Error in parsing JSON:', e);
    }
  }
  return null;
}